<style>
    @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Device Renewal" title="Requested Devices" />

        <div class="container-fluid">
           
            <div class="card">
                <div class="card-body">

                    <div class="col-md-12 project-list filter-sort mb-3">
                        <div class="row">
                            <div class="col-md-4 d-flex align-items-end gap-3">
                                <div>
                                    <label class="control-label d-block">Total Devices:</label>
                                    <span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
                                </div>
                                <button type="button" class="btn btn-success" @click="downloadRequestedDevicesExcel()" :disabled="!start_date || !end_date || excel_loading">
                                    {{ excel_loading ? 'Exporting...' : 'Export Excel' }}
                                </button>
                            </div>
                            <div class="col-md-2">
                                <label class="control-label">Renewal Type:</label>
                                <select class="form-select" v-model="renewal_type" @change="fetchRequestedDevices()">
                                    <option value="">All Types</option>
                                    <option value="1">Normal</option>
                                    <option value="2">SIM Change</option>
                                    <option value="3">Replacement</option>
                                    <option value="4">Noraml SIM Change</option>
                                    <option value="5">Extension</option>
                                    <option value="6">Topup</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="control-label">Start Date:</label>
                                <input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchRequestedDevices()">
                            </div>
                            <div class="col-md-3">
                                <label class="control-label">End Date:</label>
                                <input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchRequestedDevices()">
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 project-list filter-sort">
                        <div class="row">
                            <div class="col-md-10 d-flex">
                                <label class="d-flex listing-length"><span>Show</span>
                                    <select class="form-select" v-model="listing_length" @change="fetchRequestedDevices()">
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                    </select>
                                    <span>entries</span>
                                </label>
                            </div>
                            <div class="col-md-2">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @input="fetchRequestedDevices()" />
                                </div>
                            </div>
                        </div>
                    </div>
                                
                    <div class="table-responsive product-table">
                        <table class="display" id="basic-1" >
                            <thead>
                                <tr align="center">
                                    <th>Device Details</th>
                                    <th>Expiry</th>
                                    <th>Request By</th>
                                    <th>Status</th>
                                    <th>Payment Type</th>
                                    <th>Amount</th>
                                    <th>Payment Status</th>
                                    <th>Renewal Type</th>
                                    <th>Validity</th>
                                    <th>Viewed By</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody v-if="Boolean(requested_devices.length)">
                                <tr v-for="(device) in requested_devices" :key="device.device_id" align="center">
                                    <td>
                                        <b>IMEI:-</b>{{ device.imei }} <br> 
										<b>ICCID:-</b>{{ device.iccid }} <br>
										<b>SIM Provider:-</b>{{ device.sim_provider || '-' }}<br>
                                        <b>Device Model:-</b>{{ device.device_model || '-' }}<br>
                                        <span v-if="device.vehicle_no">Vehicle No:{{ device.vehicle_no }}</span><br>
									</td>
                                    <td>
                                        <span v-if="device.expirationtime">{{ $filters.formatDateTime(device.expirationtime) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td><b>{{ device.requested_staff }}</b> <br>
                                        {{ device.requested_on ? $filters.formatDateTime(device.requested_on) : '' }}
                                    </td>
                                    <!-- <td>
                                        <span class="badge rounded-pill bg-warning" v-if="device.status==2">Pending</span>
                                        <span class="badge rounded-pill bg-danger" v-if="device.status==3">Enquiry</span>
                                        <span class="badge rounded-pill bg-info" v-if="device.status==4">Recharge Requested</span>
                                        <span class="badge rounded-pill bg-success" v-if="device.status==5">Recharge Completed</span>
                                    </td> -->
                                    <td>
                                        <span class="badge rounded-pill bg-info" v-if="device.recharge_request_status==1">Assigned</span>
                                        <span class="badge rounded-pill bg-success" v-else-if="device.recharge_request_status==2">Completed</span>
                                        <span class="badge rounded-pill bg-danger" v-else>Not Assigned</span>
                                    </td>
                                    <td>
                                        <span class="badge rounded-pill bg-primary" v-if="device.payment_type==1">Cash</span>
                                        <span class="badge rounded-pill bg-secondary" v-if="device.payment_type==2">Online</span>
                                        <span class="badge rounded-pill bg-success" v-if="device.payment_type==3">Both</span>
                                    </td>
                                    <td>Total: {{ device.amount }} <br> Cash: {{ device.cash_in_hand }} <br> Online: {{ device.cash_online }} <br> Balance: {{ device.balance_amount }}</td>
                                    <td>
                                        <span class="badge rounded-pill bg-success" v-if="device.payment_status==1">Received</span>
                                        <span class="badge rounded-pill bg-danger" v-if="device.payment_status==2">Not Received</span>
                                        <span class="badge rounded-pill bg-warning" v-if="device.payment_status==3">Partially Received</span>
                                    </td>
                                    <td>
                                        <div v-if="device.is_topup==1">
                                            <span class="badge rounded-pill bg-success">Topup</span> <br>
                                        </div>
                                        <div v-else>
                                            <span class="badge rounded-pill bg-primary" v-if="device.renewal_type==1">Normal</span>
                                            <span class="badge rounded-pill bg-info" v-if="device.renewal_type==2">SIM Change</span>
                                            <span class="badge rounded-pill bg-primary" v-if="device.renewal_type==3">Replacement</span>
                                            <span class="badge rounded-pill bg-info" v-if="device.renewal_type==4">Noraml SIM Change</span>
                                            <span class="badge rounded-pill bg-secondary" v-if="device.renewal_type==5">Extension</span>
                                        </div>

                                        <span v-if="device.renewal_type== 2 || device.renewal_type== 4">
                                            <span class="badge rounded-pill bg-info" v-if="device.sim_change_status==1">Pending</span>
                                            <span class="badge rounded-pill bg-success" v-if="device.sim_change_status==2">Completed</span>
                                        </span>

                                        <span v-if="device.from_service== 1">
                                            <span class="badge rounded-pill bg-warning">From Service</span>
                                        </span>
                                    </td>
                                    <td>
                                        <div v-if="device.is_topup==1">
                                            <span class="badge rounded-pill bg-secondary">{{ device.topup_validity }} Days</span>
                                        </div>
                                        <div v-else>
                                            <span class="badge rounded-pill bg-secondary">{{ device.certificate_validity }} Year</span>
                                        </div>
                                    </td>
                                    <td>{{ device.request_view_staff }}</td>
                                    <td>
                                        <a class="btn btn-primary btn-sm mt-2 me-2 mb-2" @click="markAsRechargeCompleted(device)" v-if="canMarkAsRechargeCompleted(device) && !usesVodafoneRechargeFlow(device)">Mark As Recharge Completed</a>
                                        <a class="btn btn-primary btn-sm mt-2 me-2 mb-2" @click="goToIccidDetails(device)" v-if="canVodafoneIccidDetails(device)">Mark As Recharge Completed</a>
                                        <a class="btn btn-success btn-sm mt-2 me-2 mb-2" @click="openExtensionModal(device)" v-if="canCompleteExtension(device) && !usesVodafoneRechargeFlow(device)">Extension</a>
                                        <a class="btn btn-success btn-sm mt-2 me-2 mb-2" @click="goToIccidDetails(device)" v-if="canCompleteExtension(device) && usesVodafoneRechargeFlow(device)">Extension</a>
                                        <a class="btn btn-info btn-sm mt-2 me-2 mb-2" @click="openSimDataModal(device)" v-if="canShowSimData(device)">Show SIM Data</a>
                                        <a class="btn btn-secondary btn-sm mt-2 me-2 mb-2" @click="assignRechargeRequest(device)" v-if="device.recharge_request_status == null && device.request_view_by != null && isViewedByCurrentUser(device) && !usesVodafoneRechargeFlow(device)">Assign Request</a>
                                        <a class="btn btn-success btn-sm mt-2 me-2 mb-2" href="#" :class="{ 'disabled': isMarkAsViewedDisabled(device) }" @click.prevent="isMarkAsViewedDisabled(device) ? null : markAsViewed(device)" v-if="device.request_view_by == null">Mark As Viewed</a>
                                        <a class="btn btn-warning btn-sm mt-2 me-2 mb-2" @click="openUpdateRenewalModal(device)" v-if="$canUpdateRenewalData()">Update Renewal Data</a>
                                        <a
                                            class="btn btn-danger btn-sm mt-2 me-2 mb-2"
                                            @click="confirmRevokeRenewalOrExtension(device)"
                                            v-if="$canUpdateRenewalData() && (device.renewal_type == 1 || device.renewal_type == 5) && Number(device.is_topup) !== 1"
                                        >
                                            {{ device.renewal_type == 5 ? 'Revoke Extension Request' : 'Revoke Renewal Request' }}
                                        </a>
                                        <router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
                                    </td>
                                </tr>
                                
                            </tbody>

                            <tbody v-else>
                                <tr>
                                    <td colspan="12" align="center">No data available</td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <!----pagination starts --->
                    <caption v-if="Boolean(requested_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
                    <nav aria-label="Page navigation" class="mt-2 float-end">
                        <ul class="pagination">
                            <li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
                                <a class="page-link" href="#" @click.prevent="page.url && fetchRequestedDevices(buildQueryString(page.url))" tabindex="-1">
                                    <span v-if="index == 0">Prev</span>
                                    <span v-else-if="index == pagination.length - 1">Next</span>
                                    <span v-else>{{ page.label }}</span>
                                </a>
                            </li>
                        </ul>
                    </nav>  
                    <!----pagination ends --->
                </div>

            </div>

            <UpdateRenewalDataModal
                ref="updateRenewalModal"
                modal-id="updateRenewalDataModalRequested"
                :allow-certificate-validity="true"
                @updated="fetchRequestedDevices(active_page_url || undefined)"
            />
        </div>

        <!-- Extension: valid from date (same pattern as recharged.vue renew modal) -->
        <div class="modal fade" id="extensionModalRequested" tabindex="-1" aria-labelledby="extensionModalRequestedLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="extensionModalRequestedLabel">Complete extension</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group mb-0">
                            <label class="control-label" for="extensionValidFromInput">Valid from</label>
                            <input
                                id="extensionValidFromInput"
                                type="date"
                                class="form-control"
                                v-model="extensionValidFrom"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-success" @click="submitExtensionFromModal" :disabled="extensionSubmitting">
                            Complete
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Vodafone SIM data -->
        <div class="modal fade" id="simDataModalRequested" tabindex="-1" aria-labelledby="simDataModalRequestedLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="simDataModalRequestedLabel">Vodafone SIM Data</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="simDataModal.loading" class="text-center py-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div v-else-if="simDataModal.error" class="alert alert-danger mb-0">{{ simDataModal.error }}</div>
                        <div v-else-if="simDataModal.details" class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <tbody>
                                    <tr>
                                        <th style="width: 35%">ICCID</th>
                                        <td>{{ simDataModal.details.iccid || "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Primary TSP Name</th>
                                        <td>{{ simDataModal.details.Primary_TSP_Name || "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Fallback TSP Name</th>
                                        <td>{{ simDataModal.details.Fallback_TSP_Name || "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Primary TSP MSISDN</th>
                                        <td>{{ simDataModal.details.Primary_TSP_MSISDN || "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Fallback TSP MSISDN</th>
                                        <td>{{ simDataModal.details.Fallback_TSP_MSISDN || "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Primary TSP Validity</th>
                                        <td>{{ simDataModal.details.Primary_TSP_Validity ? $filters.formatDate(simDataModal.details.Primary_TSP_Validity) : "—" }}</td>
                                    </tr>
                                    <tr>
                                        <th>Fallback TSP Validity</th>
                                        <td>{{ simDataModal.details.Fallback_TSP_Validity ? $filters.formatDate(simDataModal.details.Fallback_TSP_Validity) : "—" }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import { Modal } from 'bootstrap'
import UpdateRenewalDataModal from '@/components/renewal/UpdateRenewalDataModal.vue'

export default {
    name: "Device Renewal",
    components: { UpdateRenewalDataModal },

        data() {

            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
            const minDate = new Date('2024-01-01')
            const maxDate = new Date().toISOString().slice(0, 10) // Format: YYYY-MM-DD

            return {
                // start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                // 	.toISOString()
                // 	.slice(0, 10),
                end_date: new Date().toISOString().slice(0, 10), // today's date (YYYY-MM-DD)

                start_date: '',
                
                keyword: "",
                listing_length: 20,
                token: "",
                searchTimeout: null,
                requested_devices:[],
                pagination: {},
                from: 0,
                to: 0,
                total: 0,
                active_page_url: "",
                max: maxDate,
                renewal_type: "",
                excel_loading: false,

                type: "",

                device_id: {
                    id: "",
                },

                errors: {},
                refreshIntervalId: null,

                extensionModalInstance: null,
                extensionDeviceId: null,
                extensionValidFrom: '',
                extensionCertificateValidity: null,
                extensionSubmitting: false,

                simDataModalInstance: null,
                simDataModal: {
                    iccid: "",
                    loading: false,
                    error: "",
                    details: null,
                },
            };
        },

        mounted() {
            const extensionEl = document.getElementById('extensionModalRequested');
            if (extensionEl) this.extensionModalInstance = new Modal(extensionEl);
            const simDataEl = document.getElementById('simDataModalRequested');
            if (simDataEl) this.simDataModalInstance = new Modal(simDataEl);
        },

        created() {
            this.fetchRequestedDevices();
            this.startRefreshInterval();
        },

        beforeUnmount() {
            this.clearRefreshInterval();
        },

        methods: {

            openUpdateRenewalModal(device) {
                this.$refs.updateRenewalModal?.open(device);
            },

            canRevokeRenewalOrExtension(device) {
                if (!device) return false;
                if (!this.$canUpdateRenewalData || !this.$canUpdateRenewalData()) return false;
                if (Number(device.is_topup) === 1) return false;
                const type = Number(device.renewal_type);
                return type === 1 || type === 5;
            },

            revokeRenewalButtonLabel(device) {
                return Number(device?.renewal_type) === 5 ? 'Revoke Extension Request' : 'Revoke Renewal Request';
            },

            confirmRevokeRenewalOrExtension(device) {
                if (!this.canRevokeRenewalOrExtension(device)) return;
                const label = this.revokeRenewalButtonLabel(device);
                this.$swal.fire({
                    title: label + '?',
                    html: 'This will reverse any received/partial payment and reset the renewal request.',
                    icon: 'warning',
                    position: 'center',
                    input: 'textarea',
                    inputLabel: 'Remarks',
                    inputPlaceholder: 'Enter remarks for this revoke…',
                    inputAttributes: {
                        'aria-label': 'Remarks',
                    },
                    inputValidator: (value) => {
                        if (!value || !String(value).trim()) {
                            return 'Remarks is required';
                        }
                        return null;
                    },
                    showCancelButton: true,
                    showConfirmButton: true,
                    toast: false,
                    timer: undefined,
                    confirmButtonText: 'Yes, revoke',
                    cancelButtonText: 'Cancel',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.revokeRenewalOrExtension(device, String(result.value || '').trim());
                    }
                });
            },

            revokeRenewalOrExtension(device, remarks) {
                this.getToken();
                this.$axios
                    .post(
                        '/staffs/revokeRenewalOrExtension',
                        { device_id: device.id, remarks },
                        { headers: { Authorization: 'Bearer ' + this.token } }
                    )
                    .then((res) => {
                        const ok = res.data?.status === true || res.data?.status === 'true';
                        if (!ok) {
                            this.$swal('', res.data?.message || 'Failed to revoke', 'error');
                            return;
                        }
                        this.$swal('', res.data?.message || 'Revoked successfully', 'success');
                        this.fetchRequestedDevices(this.active_page_url || undefined);
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message;
                        this.$swal('', typeof msg === 'string' ? msg : 'Failed to revoke', 'error');
                    });
            },

            getToken() {
                if (localStorage.getItem('airotrack_staff')) {
                    var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
                            
                    if(airotrack_staff.token) {

                        this.token = airotrack_staff.token;
                        this.user = airotrack_staff;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            },

            isViewedByCurrentUser(device) {
                if (!device || device.request_view_by == null || device.request_view_by === "") return false;
                if (!this.user || (this.user.id == null && this.user.user_id == null)) {
                    this.getToken();
                }
                const loginUserId = this.user?.id ?? this.user?.user_id ?? null;
                if (loginUserId == null || loginUserId === "") return false;
                return String(loginUserId) === String(device.request_view_by);
            },

            isVodafoneSimProvider(device) {
                const raw = String(device?.sim_provider || "").trim().toLowerCase();
                if (!raw) return false;
                const normalized = raw.replace(/\s*\+\s*/g, " ").replace(/\s+/g, " ").trim();
                if (normalized === "vodafone") return true;
                return normalized.includes("vodafone") && normalized.includes("idea");
            },

            isTrancoDevice(device) {
                return String(device?.device_model || "").trim().toLowerCase() === "tranco";
            },

            // Vodafone Idea devices take the ICCID details flow, except TRANCO which uses the non-Vodafone recharge flow
            usesVodafoneRechargeFlow(device) {
                return this.isVodafoneSimProvider(device) && !this.isTrancoDevice(device);
            },

            canShowSimData(device) {
                return this.usesVodafoneRechargeFlow(device) && String(device?.iccid || "").trim() !== "";
            },

            openSimDataModal(device) {
                const iccid = String(device?.iccid || "").trim();
                if (!iccid) {
                    this.$swal("", "ICCID not available for this device", "error");
                    return;
                }
                this.getToken();
                this.simDataModal.iccid = iccid;
                this.simDataModal.loading = true;
                this.simDataModal.error = "";
                this.simDataModal.details = null;
                if (this.simDataModalInstance) this.simDataModalInstance.show();
                this.$axios
                    .get("/staffs/iccidDetails", {
                        params: { iccid },
                        headers: { Authorization: "Bearer " + this.token },
                    })
                    .then((res) => {
                        const ok = res.data?.status === true || res.data?.status === "true";
                        if (ok && res.data?.data) {
                            this.simDataModal.details = res.data.data;
                        } else {
                            this.simDataModal.error = res.data?.message || "Failed to fetch SIM data";
                        }
                    })
                    .catch((err) => {
                        this.simDataModal.error = err?.response?.data?.message || "Something went wrong";
                    })
                    .finally(() => {
                        this.simDataModal.loading = false;
                    });
            },

            canMarkAsRechargeCompleted(device) {
                if (!device) return false;
                if (String(device.recharge_request_status) === "2") return false;
                // Topup follows normal renewal/recharge flow (not extension)
                const isTopup = Number(device.is_topup) === 1;
                if (!isTopup && String(device.renewal_type) === "5") return false;
                // Only request_view_by staff can mark recharge completed
                if (!this.isViewedByCurrentUser(device)) return false;
                // Replacement without device swap: Vodafone / Vodafone + Idea only
                if (String(device.renewal_type) === "3" && !this.usesVodafoneRechargeFlow(device)) return false;
                // Vodafone skips assign — show after mark as viewed
                if (this.usesVodafoneRechargeFlow(device)) {
                    return true;
                }
                return String(device.recharge_request_status) === "1";
            },

            canCompleteExtension(device) {
                if (!device || String(device.renewal_type) !== "5") return false;
                // Topup is not extension — use Mark As Recharge Completed / renew flow
                if (Number(device.is_topup) === 1) return false;
                if (String(device.recharge_request_status) === "2") return false;
                if (!this.isViewedByCurrentUser(device)) return false;
                if (this.usesVodafoneRechargeFlow(device)) {
                    return true;
                }
                return String(device.recharge_request_status) === "1";
            },

            canVodafoneIccidDetails(device) {
                // Same viewer restriction as non-Vodafone Mark As Recharge Completed
                return this.usesVodafoneRechargeFlow(device) && this.canMarkAsRechargeCompleted(device);
            },

            getDeviceRenewalId(device) {
                if (!device) return "";
                if (device.device_renewal && device.device_renewal.id != null) {
                    return String(device.device_renewal.id);
                }
                if (device.device_renewal_id != null) return String(device.device_renewal_id);
                if (device.id != null) return String(device.id);
                return "";
            },

            getDeviceExpirationtime(device) {
                if (!device) return "";
                const value = device.expirationtime ?? device.expiration_time ?? device.expire_on ?? "";
                return value ? String(value) : "";
            },

            goToIccidDetails(device) {
                const iccid = String(device?.iccid || "").trim();
                const deviceRenewalId = this.getDeviceRenewalId(device);
                const expirationtime = this.getDeviceExpirationtime(device);
                if (!iccid) {
                    this.$swal("", "ICCID not available for this device", "error");
                    return;
                }
                if (!deviceRenewalId) {
                    this.$swal("", "Device renewal ID not available", "error");
                    return;
                }
                this.$router.push({
                    name: "iccid_details",
                    params: { device_id: deviceRenewalId },
                    query: {
                        device_id: deviceRenewalId,
                        iccid,
                        imei: device.imei || "",
                        renewal_type: device.renewal_type != null ? String(device.renewal_type) : "",
                        expirationtime: expirationtime ? encodeURIComponent(expirationtime) : "",
                    },
                    state: { expirationtime },
                });
            },

            isMarkAsViewedDisabled(device) {
                if (!device) return false;
                const renewalType2Or4 = device.renewal_type == 2 || device.renewal_type == 4;
                const simChangeDone = device.sim_change_status == 1;
                return renewalType2Or4 && simChangeDone;
            },

            startRefreshInterval() {
                this.clearRefreshInterval();
                this.refreshIntervalId = setInterval(() => {
                    this.fetchRequestedDevices(this.active_page_url || undefined);
                }, 20000);
            },

            clearRefreshInterval() {
                if (this.refreshIntervalId) {
                    clearInterval(this.refreshIntervalId);
                    this.refreshIntervalId = null;
                }
            },

            buildQueryString(pageUrl = null) {
                const params = new URLSearchParams();
                params.append("limit", this.listing_length);
                params.append("keyword", String(this.keyword || "").trim());
                params.append("from_date", this.start_date || "");
                params.append("to_date", this.end_date || "");
                params.append("renewal_type", this.renewal_type || "");
                if (pageUrl) {
                    const pageMatch = String(pageUrl).match(/[?&]page=(\d+)/);
                    if (pageMatch) {
                        params.append("page", pageMatch[1]);
                    }
                }
                return "/staffs/rechargeRequestedDevices?" + params.toString();
            },

            fetchRequestedDevices(page_url = null) {
                this.getToken();
				const url = page_url || this.buildQueryString();
				this.active_page_url = url;
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.requested_devices = responseData.requested_devices.data;
						this.pagination = responseData.requested_devices.links;
						this.from = responseData.requested_devices.from;
						this.to = responseData.requested_devices.to;
						this.total = responseData.requested_devices.total;
						
					})
					.catch((err) => console.log(err));
            },

            downloadRequestedDevicesExcel() {
                if (!this.start_date || !this.end_date) return;

                this.getToken();
                const params = new URLSearchParams({
                    keyword: String(this.keyword || "").trim(),
                    from_date: this.start_date,
                    to_date: this.end_date,
                    renewal_type: this.renewal_type || "",
                });
                this.excel_loading = true;
                this.$axios
                    .get("/staffs/rechargeRequestedDevicesExcel?" + params.toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "requested_devices_" + this.start_date + "_" + this.end_date + ".xlsx";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(link.href);
                    })
                    .catch((err) => console.log(err))
                    .finally(() => {
                        this.excel_loading = false;
                    });
            },

            markAsRechargeCompleted(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to mark as recharge completed?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.device_id.id = device.id;
						this.completeRecharge();
					}
				});
			},

            todayIsoDate() {
				const d = new Date();
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				return `${y}-${m}-${day}`;
			},

			openExtensionModal(device) {
				this.getToken();
				this.extensionDeviceId = device.id;
				const expiration = this.getDeviceExpirationtime(device);
				const expirationDate = expiration ? String(expiration).slice(0, 10) : "";
				this.extensionValidFrom = /^\d{4}-\d{2}-\d{2}$/.test(expirationDate)
					? expirationDate
					: this.todayIsoDate();
				this.extensionCertificateValidity = device.certificate_validity != null && device.certificate_validity !== ''
					? Number(device.certificate_validity)
					: null;
				this.extensionSubmitting = false;
				if (this.extensionModalInstance) this.extensionModalInstance.show();
			},

			submitExtensionFromModal() {
				this.getToken();
				if (!this.extensionDeviceId) return;
				if (!this.extensionValidFrom) {
					this.$swal('', 'Please select a valid from date.', 'error');
					return;
				}
				const years = this.extensionCertificateValidity != null && !Number.isNaN(this.extensionCertificateValidity)
					? this.extensionCertificateValidity
					: '-';
				const yearLabel = years === 1 ? 'year' : 'years';
				const validFromDisplay = this.$filters?.formatDate
					? this.$filters.formatDate(this.extensionValidFrom)
					: this.extensionValidFrom;
				this.$swal.fire({
					title: 'Confirm Extension',
					text: `Are you sure want to renew the device validity from ${validFromDisplay} to ${years} ${yearLabel}.`,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					toast: false,
					timer: undefined,
					confirmButtonText: 'Yes, renew',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (!result.isConfirmed) return;
					this.extensionSubmitting = true;
					const config = {
						headers: {
							Authorization: "Bearer " + this.token,
						},
					};
					this.$axios
						.post(
							"/staffs/completeExtension",
							{
								device_id: this.extensionDeviceId,
								valid_from: this.extensionValidFrom,
							},
							config
						)
						.then((response) => {
							if (response.data.status === true || response.data.status === "true") {
								if (this.extensionModalInstance) this.extensionModalInstance.hide();
								this.$swal("", response.data.message || "Extension completed", "success");
							} else {
								this.$swal("", response.data.message || "Request failed", "error");
							}
							this.fetchRequestedDevices(this.active_page_url);
						})
						.catch((error) => {
							if (error.response && error.response.data && error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						})
						.finally(() => {
							this.extensionSubmitting = false;
						});
				});
			},

			completeRecharge() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/rechargeComplete?device_id=" + this.device_id.id, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchRequestedDevices(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			assignRechargeRequest(device) {
				this.$swal({
					icon: 'warning',
					title: "Confirm",
					text: 'Are you sure you want to assign this request to network provider?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
				}).then((result) => {
					if (result.value) {
						this.submitAssignRecharge(device.id);
					}
				});
			},

			submitAssignRecharge(deviceId) {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/assignRecharge?device_id=" + deviceId, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchRequestedDevices(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			markAsViewed(device) {
            this.$swal({
                icon: 'warning',
                title: "Confirm",
                text: 'Are you sure you want to mark as viewed?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                confirmButtonColor: '#e64942',
                cancelButtonText: 'No',
                position: "center",
                showConfirmButton: true,
                timer: '',
                toast: false,
                cancelButtonColor: '#efefef',
            }).then((result) => {
                if (result.value) {
                    this.submitMarkAsViewed(device.id);
                }
            });
		},

        submitMarkAsViewed(deviceId) {
            const config = {
                headers: {
                    Authorization: "Bearer " + this.token,
                },
            };
            this.$axios
                .get("/staffs/requestViewed?device_id=" + deviceId, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchRequestedDevices(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                });
        }
    }
};
</script>
